module.exports = __webpack_public_path__ + "static/media/apple-podcasts-button.ba18cb55.jpg";